// Página de seleção de tipos de cadastro
import { useNavigate } from 'react-router-dom';
import { Card } from '../../components/common/Card';
import { Button } from '../../components/common/Button';
import { Breadcrumbs } from '../../components/layout/Breadcrumbs';
import { Users, Building2, Package, Briefcase, Building, Truck } from 'lucide-react';

export function Cadastros() {
  const navigate = useNavigate();
  
  const tiposCadastro = [
    {
      id: 'clientes',
      nome: 'Clientes',
      descricao: 'Cadastro de clientes',
      descricaoCompleta: 'Gerencie seus clientes, pessoas físicas e jurídicas.',
      icon: Users,
      path: '/app/cadastros/clientes',
      cor: 'bg-blue-500',
      corHover: 'hover:bg-blue-600',
    },
    {
      id: 'fornecedores',
      nome: 'Fornecedores',
      descricao: 'Cadastro de fornecedores',
      descricaoCompleta: 'Gerencie seus fornecedores e parceiros comerciais.',
      icon: Building2,
      path: '/app/cadastros/fornecedores',
      cor: 'bg-green-500',
      corHover: 'hover:bg-green-600',
    },
    {
      id: 'produtos',
      nome: 'Produtos',
      descricao: 'Cadastro de produtos',
      descricaoCompleta: 'Gerencie seu catálogo de produtos e estoque.',
      icon: Package,
      path: '/app/cadastros/produtos',
      cor: 'bg-purple-500',
      corHover: 'hover:bg-purple-600',
    },
    {
      id: 'servicos',
      nome: 'Serviços',
      descricao: 'Cadastro de serviços',
      descricaoCompleta: 'Gerencie seu catálogo de serviços oferecidos.',
      icon: Briefcase,
      path: '/app/cadastros/servicos',
      cor: 'bg-orange-500',
      corHover: 'hover:bg-orange-600',
    },
    {
      id: 'empresa',
      nome: 'Empresa',
      descricao: 'Dados da empresa',
      descricaoCompleta: 'Configure os dados da sua empresa emitente.',
      icon: Building,
      path: '/app/cadastros/empresa',
      cor: 'bg-red-500',
      corHover: 'hover:bg-red-600',
    },
    {
      id: 'transportadora',
      nome: 'Transportadora',
      descricao: 'Cadastro de transportadoras',
      descricaoCompleta: 'Gerencie as transportadoras para envio de produtos.',
      icon: Truck,
      path: '/app/cadastros/transportadora',
      cor: 'bg-indigo-500',
      corHover: 'hover:bg-indigo-600',
    },
  ];
  
  return (
    <div className="space-y-6">
      <Breadcrumbs items={[{ label: 'Cadastros' }]} />
      
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">Cadastros</h1>
          <p className="text-gray-600 dark:text-gray-400 mt-1">
            Gerencie todos os cadastros do sistema
          </p>
        </div>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {tiposCadastro.map((tipo) => {
          const Icon = tipo.icon;
          return (
            <div
              key={tipo.id}
              className="cursor-pointer"
              onClick={() => navigate(tipo.path)}
            >
              <Card className="hover:shadow-lg transition-shadow h-full">
                <div className="flex flex-col items-center text-center p-6">
                  <div className={`w-16 h-16 ${tipo.cor} rounded-full flex items-center justify-center mb-4 transition-transform hover:scale-110`}>
                    <Icon className="w-8 h-8 text-white" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 dark:text-gray-100 mb-2">
                    {tipo.nome}
                  </h3>
                  <p className="text-sm font-medium text-gray-600 dark:text-gray-400 mb-2">
                    {tipo.descricao}
                  </p>
                  <p className="text-sm text-gray-500 dark:text-gray-500 mb-4">
                    {tipo.descricaoCompleta}
                  </p>
                  <Button
                    variant="primary"
                    className={`w-full ${tipo.corHover}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(tipo.path);
                    }}
                  >
                    Acessar {tipo.nome}
                  </Button>
                </div>
              </Card>
            </div>
          );
        })}
      </div>
    </div>
  );
}

